// extracted by mini-css-extract-plugin
export default {"textMessage":"style_textMessage__AlJaw"};